<template>
    <zen-one :showuserinfo="false" title="Pentadbiran" :crumbs="crumbs">
        <z-page title="Pengurusan Pengguna">

        <w-flex justify-space-between class="mb4">
                    
                    <div class="xs4"> 
                        <w-input label="Nama" v-model="cari.name" name="name" />
                    </div>
                    <div class="xs4"> 
                        <w-input label="No. Kad Pengenalan" v-model="cari.no_id" name="no_id" />
                    </div>
                    <div class="xs4"> 
                       <w-input label="Email" v-model="cari.email" name="email" />
                    </div>
                </w-flex>

                 <div class="mt2 mb2 text-right">
                 <w-button class="ml1" v-on:click="reset()" :loading="cari.loading" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="carian()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-dark1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-cog</w-icon>
                    Kemaskini
                </template>

                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
                        <w-flex justify-space-between class="mb4">
                            <z-input label="Email *" v-model="form.email" name="email" :validators="[validators.required]" />
                        </w-flex>
                     </w-form>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                    >
                        Simpan
                    </w-button>
                </template>
            </w-dialog>

            <z-table
                ref="tbluser"
                title="Senarai Pengguna iBayaq"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        <w-icon xs>fal fa-pencil</w-icon>
                    </template>
                    <template v-else>
                        {{ label }}
                    </template>
                </template>

                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <template
                            v-if="
                                $zutil.can('ADMIN_JABATAN') ||
                                $zutil.can('ADMIN_BENDAHARI')
                            "
                        >
                            <w-button
                                class="fs-2 pr3 bs"
                                bg-color="primary-dark1"
                                tile
                                @click="edit(item)"
                            >
                                <w-icon xs class="mr2">fal fa-pencil</w-icon>
                            </w-button>
                           <!--  <w-button
                                class="fs-2"
                                bg-color="error-dark1"
                                dark
                                tile
                                @click="destroy(item)"
                            >
                                <w-icon xs class="mr2">fal fa-trash</w-icon>
                            </w-button> -->
                        </template>
                        <w-button
                            bg-color="info-dark1"
                            dark
                            tile
                            :route="$route('user_ibayar.show', item.id)"
                            class="be fs-2"
                        >
                            <w-icon xs class="mr2">fal fa-eye</w-icon>
                        </w-button>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZResource from '@/Modules/z-resource'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_ibayaq + "user_profil",
            // resourceurl: 'admin.user',
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Utama", route: "/" },
                { label: "Pentadbiran", route: "/admin/user" },
                { label: "Pengguna", route: "/admin/user" },
            ],
            cari : { name: '', email: '', no_id: ''},

            form: {
                id: 0,
                name: "",
                email: "",
                status: "",
                status_login: "",
                jabatan_id: "",
                phone_number: "",
            },
        };
    },
    methods: {
         carian() {
             this.$inertia.visit(window.route('user_ibayar.index')+'?name='+this.cari.name+'&email='+this.cari.email+'&no_id='+this.cari.no_id , {preserveScroll:true})
    },
    
     // reset(){
     //          this.cari = {nama_id:'', no_resit:'', tarikh_dari:'', tarikh_hingga: '', lkp_resit_status_id: '', user_id: '', lkp_cara_bayaran_id: '', no_dokumen: ''}
     //          this.carian()
     //    },

    reset(){
              this.cari = {name: '', no_id: '', email: ''}
              this.carian()
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 500;
    },
};
</script>
